// dependencies
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components\
import Logo from "assets/img/logo";
import GoogleLogo from "assets/img/OtherLogos/google";
import Button from "Components/Button";
import TextInput from "Components/Inputs/Text";

// actions
import { init, inputChange, authenticate, authenticateGoogle } from "./actions";

// selectors
import { getIsRequesting } from "Selectors/app";
import { getEmail, getPassword } from "./selectors";

// styles
import css from "./Login.styl";

class LoginPage extends React.Component {
	static propTypes = {
		isRequesting: PropTypes.bool.isRequired,
		isRequestingOAuth: PropTypes.bool.isRequired,
		changeInput: PropTypes.func.isRequired,
		init: PropTypes.func.isRequired,
		authenticate: PropTypes.func.isRequired,
		email: PropTypes.string.isRequired,
		password: PropTypes.string.isRequired,
	};

	componentDidMount = () => {
		this.props.init();
	};

	handleKeyDown = (event) => {
		if (event.key === "Enter") {
			this.handleAuthenticate();
		}
	};

	handleEmailChange = (value) => {
		this.props.changeInput("email", value);
	};

	handlePasswordChange = (value) => {
		this.props.changeInput("password", value);
	};

	handleAuthenticate = () => {
		this.props.authenticate();
	};

	handleAuthenticateGoogle = () => {
		this.props.authenticateGoogle();
	};

	render = () => {
		const { email, password, isRequesting, isRequestingOAuth } = this.props;

		return (
			<div className={css.loginPage}>
				<div className={css.loginContainer}>
					<div className={css.logoContainer}>
						<h1>Logan</h1>
						<Logo width={150} height={150} />
					</div>

					<div className={css.formContainer}>
						<div className={css.inputContainer}>
							<div className="label">Email</div>
							<TextInput value={email} onChange={this.handleEmailChange} onKeyDown={this.handleKeyDown} />
						</div>

						<div className={css.inputContainer}>
							<div className="label">Password</div>
							<TextInput
								type="password"
								value={password}
								onChange={this.handlePasswordChange}
								onKeyDown={this.handleKeyDown}
							/>
						</div>

						<div className={css.inputContainer}>
							<Button
								isRequesting={isRequesting}
								onClick={this.handleAuthenticate}
								className={css.loginButton}
							>
								Login
							</Button>
						</div>

						<div className={css.inputContainer}>
							<button
								onClick={this.handleAuthenticateGoogle}
								className={css.googleButton}
								disabled={isRequestingOAuth}
							>
								<div className={css.iconWrapper}>
									<GoogleLogo height={32} width={32} />
								</div>
								<div className={css.label}>Sign in with Google</div>
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	email: getEmail(state),
	password: getPassword(state),
	isRequesting: getIsRequesting(state, "USERS:GET"),
	isRequestingOAuth: getIsRequesting(state, "OAUTH:GET"),
});

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(init()),
	authenticate: () => dispatch(authenticate()),
	authenticateGoogle: () => dispatch(authenticateGoogle()),
	changeInput: (name, value) => dispatch(inputChange(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
